//This is for config, vars that are used everywhere and when they change, I want to change one time only
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = `0d1e7497-bf05-4f55-bbfc-ce47a6b9b479`;
